import { memo } from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { EXECUTION_REPORT_PANEL_TABS } from "constants/flowDesigner";
import { getEnv } from "helpers/environment";

const ExecutionPanelTabs = styled(Tabs)(() => ({
  borderBottom: 1,
  borderColor: "divider",
  borderRadius: 0,
  width: "100%"
}));

const a11yProps = (index) => {
  return {
    id: `horizontal-tab-${index}`,
    "aria-controls": `horizontal-tabpanel-${index}`
  };
};

const ExecutionReportTabs = ({ tabValue, handleChange }) => {
  const isTabActive = (tabKey) => {
    const envVarName = `EXECUTION_REPORT_TAB_${tabKey}`;
    return getEnv(envVarName);
  };

  return (
    <ExecutionPanelTabs
      orientation="horizontal"
      variant="contained"
      //scrollButtons={Object.keys(EXECUTION_REPORT_PANEL_TABS).length > 0}
      value={tabValue}
      onChange={handleChange}
    >
      {Object.keys(EXECUTION_REPORT_PANEL_TABS)
        .filter((tab) => isTabActive(tab))
        .map((tab, index) => (
          <Tab
            key={index}
            className="execution-report-tab"
            label={EXECUTION_REPORT_PANEL_TABS[tab]}
            iconPosition="end"
            aria-label={EXECUTION_REPORT_PANEL_TABS[tab]}
            {...a11yProps(tab)}
          />
        ))}
    </ExecutionPanelTabs>
  );
};

export default memo(ExecutionReportTabs);
